import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { FiX } from 'react-icons/fi';

// //payload is
// label = '3 Months Payslip';
// name = 'ParentRecords_PaySlip';
// formik = { formik };
// removeDocument = { removeDocument };

interface FileUploadProps {
  label: string;
  name: string;
  formik: any;
  removeDocument: (type: any) => void;
}

const PaySlipFileUpload: React.FC<FileUploadProps> = ({
  label,
  name,
  formik,
  removeDocument,
}) => {
  const onDropPayslip = useCallback(
    (acceptedFiles: File[]) => {
      const currentFile = formik.values?.ParentRecords_PaySlip || null;
      // Process the new file
      const filteredFile = acceptedFiles.find(
        (file) => file.size <= 5 * 1024 * 1024
      );
      if (!filteredFile) {
        formik.setFieldError(
          'ParentRecords_PaySlip',
          'File size is too large. Maximum size is 5MB.'
        );
        formik.setFieldTouched('ParentRecords_PaySlip', true, false);
      } else if (filteredFile && currentFile !== null) {
        formik.setFieldError(
          'ParentRecords_PaySlip',
          'You can only upload one payslip.'
        );
        formik.setFieldTouched('ParentRecords_PaySlip', true, false);
        return;
      } else {
        formik.setFieldValue('ParentRecords_PaySlip', filteredFile);
        formik.setFieldError('ParentRecords_PaySlip', '');
      }
    },
    [formik]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onDropPayslip,
    accept: { 'image/jpeg': [], 'application/pdf': [] },
  });

  return (
    <div className="col-span-1">
      <p>
        {label} <span className="text-sm text-gray-1">(optional)</span>
      </p>
      <div className="flex items-center justify-center flex-col border rounded-md p-3">
        <div
          {...getRootProps()}
          className="flex items-center justify-center flex-col"
        >
          <input {...getInputProps()} />
          <img src="/Assets/upload.svg" className="w-12" alt="upload" />
          <p>
            <span className="text-blue-500 font-medium">Click to upload</span>{' '}
            or drag and drop
          </p>
          <p className="text-xs">.jpeg or .pdf (max. 5MB)</p>
          {formik.errors[name] && (
            <div className="text-red-500 text-xs text-center">
              {formik.errors[name] as string}
            </div>
          )}
        </div>

        {formik.values[name] && (
          <ul className="mt-2">
            <li className="flex justify-between items-center">
              <span>{formik.values[name]?.name}</span>
              <button
                type="button"
                onClick={() => removeDocument(name)}
                className="text-red-500"
              >
                <FiX />
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default PaySlipFileUpload;

// //payload is
// label = '3 Months Payslip';
// name = 'ParentRecords_PaySlip';
// formik = { formik };
// removeDocument = { removeDocument };
